export default __webpack_public_path__ + "media/images/ui-icons_2694e8_256x240-6b8a6ee80c90c79700cb483e634123b8.png";